/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';
import { ConfigureDnsModule } from 'app/feature/service/v-store-service/v-store/detail-v-store/detail-service/dns/configure-dns/configure-dns.module';
import { ConfigureServiceAdModule } from 'app/feature/settings/users-security/domain-auth/service-ad/configure-service-ad/configure-service-ad.module';
import { ConfigureServiceLdapModule } from 'app/feature/settings/users-security/domain-auth/service-ldap/configure-service-ldap/configure-service-ldap.module';
import { ConfigureServiceNisModule } from 'app/feature/settings/users-security/domain-auth/service-nis/configure-service-nis/configure-service-nis.module';

import { FileSystemGuideComponent } from './file-system-guide.component';
import { FileSystemGuideService } from './file-system-guide.service';

@NgModule({
    declarations: [FileSystemGuideComponent],
    exports: [FileSystemGuideComponent],
    imports: [
        CommonModule,
        CoreModule,
        ConfigureServiceLdapModule,
        ConfigureServiceNisModule,
        ConfigureServiceAdModule,
        ConfigureDnsModule,
    ],
    providers: [FileSystemGuideService],
})
export class FileSystemGuideModule { }
